/* KMALL09 — 자주 산 상품 (frequently bought) 260807
 *
 * 쿠팡의 "N회 구매" 배지 + "자주 산 상품" 모아보기를 같은 구조로 구현한다.
 *
 * 데이터 출처 (하이브리드 — 어느 쪽이든 동작):
 *   ① window.KM_BOUGHT_RAW — layout/theme.liquid 이 로그인 고객에게만 렌더하는
 *      [상품ID, …] 배열. 한 (주문 × 상품) 조합당 1개가 들어있어 개수를 세면
 *      곧 "구매 횟수"가 된다(같은 주문에서 2개 사도 1회로 침 — uniq 처리는 Liquid 쪽).
 *   ② localStorage 캐시 — Shopify 가 계정 템플릿 밖에서 customer.orders 를 비워 주는
 *      경우가 있어, 마이페이지/자주 산 상품 페이지에서 받은 값을 캐시해 두고
 *      컬렉션·검색에서 재사용한다. TTL 30일.
 *   로그아웃하면 KM_BOUGHT_RAW 가 안 오고 theme.liquid 가 KM_LOGGED_IN=false 를 주므로
 *   캐시를 즉시 비운다(다른 사람 기록이 남지 않게).
 *
 * 하는 일:
 *   · 카드(.kmall-pc[data-km-pid])에 "N회 구매" 칩을 꽂는다 — Liquid 카드와
 *     검색엔진(kmall-search.js)이 그리는 카드 모두. 새로 그려지는 카드는
 *     MutationObserver 로 잡는다.
 *   · 컬렉션·검색 그리드에 "자주 산 상품 먼저" 토글을 달아 현재 페이지 안에서
 *     구매한 상품을 앞으로 끌어올린다(서버 정렬은 고객별로 불가능하므로 페이지 내 재배열).
 *   · 자주 산 상품 페이지(kmall-frequent.liquid)의 검색·품절제외·정렬을 처리한다.
 */
(function () {
  'use strict';

  var LS_KEY = 'km_bought_v1';
  var TTL = 30 * 24 * 3600 * 1000;
  var PRIO_KEY = 'km_bought_prio';
  var I18N = window.KM_FREQ_I18N || {};

  /* ---------------- 데이터 ---------------- */

  function readCache() {
    try {
      var o = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
      if (!o || !o.at || !o.ids) return null;
      if (Date.now() - o.at > TTL) return null;
      return o.ids;
    } catch (e) { return null; }
  }

  function writeCache(ids) {
    try { localStorage.setItem(LS_KEY, JSON.stringify({ at: Date.now(), ids: ids })); } catch (e) {}
  }

  function clearCache() {
    try { localStorage.removeItem(LS_KEY); } catch (e) {}
  }

  /* 로그아웃 상태면 남의 기록이 남지 않도록 캐시를 비운다 */
  if (window.KM_LOGGED_IN === false) clearCache();

  var raw = null;
  if (window.KM_BOUGHT_RAW && window.KM_BOUGHT_RAW.length) {
    raw = window.KM_BOUGHT_RAW;
    writeCache(raw);
  } else if (window.KM_LOGGED_IN !== false) {
    raw = readCache();
  }

  /* pid -> 구매 횟수. 배열 뒤쪽일수록 오래된 주문(Liquid 가 최신순으로 넣음)이라
     첫 등장 인덱스가 곧 "최근 구매" 순서가 된다. */
  var counts = Object.create(null);
  var firstSeen = Object.create(null);
  if (raw) {
    for (var i = 0; i < raw.length; i++) {
      var id = String(raw[i]);
      if (!id || id === '0') continue;
      counts[id] = (counts[id] || 0) + 1;
      if (!(id in firstSeen)) firstSeen[id] = i;
    }
  }

  var HAS_ANY = Object.keys(counts).length > 0;

  var API = {
    count: function (pid) { return counts[String(pid)] || 0; },
    recency: function (pid) {
      var v = firstSeen[String(pid)];
      return v === undefined ? Infinity : v;
    },
    has: function (pid) { return !!counts[String(pid)]; },
    any: function () { return HAS_ANY; },
    all: function () { return counts; }
  };
  window.KM_FREQ = API;

  /* 로케일 문자열의 개수 자리. Liquid 이 `| t: count: '__N__'` 로 넘겨 주므로 __N__ 을
     치환한다. 번역가가 {{ count }} 를 그대로 남긴 경우도 방어적으로 함께 처리. */
  var NUM_SLOT = /__N__|\{\{\s*count\s*\}\}/g;

  function fill(tpl, n, fallback) {
    return String(tpl || fallback).replace(NUM_SLOT, n);
  }

  function label(n) {
    return fill(I18N.buyCount, n, '__N__');
  }

  /* ---------------- 카드 배지 ---------------- */

  function decorate(root) {
    if (!HAS_ANY) return;
    var cards = (root || document).querySelectorAll('.kmall-pc[data-km-pid]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.__kmFreq) continue;
      var n = API.count(card.getAttribute('data-km-pid'));
      if (!n) { card.__kmFreq = 1; continue; }
      var body = card.querySelector('.kmall-pc-body');
      if (!body) continue;
      card.__kmFreq = 1;
      card.classList.add('km-bought');
      var chip = document.createElement('span');
      chip.className = 'km-bought-chip';
      chip.textContent = label(n);
      /* 상품명 바로 위 — 쿠팡과 같은 위치 */
      var nm = body.querySelector('.kmall-pc-nm');
      if (nm) body.insertBefore(chip, nm); else body.insertBefore(chip, body.firstChild);
    }
  }

  /* 검색엔진이 그리드를 다시 그리면 새 카드가 생기므로 감시한다 */
  function watch() {
    if (!HAS_ANY || !window.MutationObserver) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { decorate(document); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------- 컬렉션·검색: 자주 산 상품 먼저 ---------------- */

  function prioOn() {
    /* 기본값 ON(260813 대표 확정) — 저장된 값이 없으면(첫 방문 등) 켠 것으로 본다.
       사용자가 명시적으로 끈 적이 있으면('0' 저장) 그 선택을 존중해 꺼진 채 유지한다. */
    try {
      var v = localStorage.getItem(PRIO_KEY);
      return v === null ? true : v === '1';
    } catch (e) { return true; }
  }
  function setPrio(v) {
    try { localStorage.setItem(PRIO_KEY, v ? '1' : '0'); } catch (e) {}
  }

  function applyPriority(grid, on) {
    if (!grid) return;
    var cards = [].slice.call(grid.querySelectorAll(':scope > .kmall-pc'));
    if (!cards.length) return;
    if (!grid.__kmOrder) {
      grid.__kmOrder = cards.slice(); /* 원래 순서 보존 */
    }
    if (!on) {
      grid.__kmOrder.forEach(function (c) { grid.appendChild(c); });
      return;
    }
    var bought = [], rest = [];
    grid.__kmOrder.forEach(function (c) {
      (API.count(c.getAttribute('data-km-pid')) ? bought : rest).push(c);
    });
    bought.sort(function (a, b) {
      return API.count(b.getAttribute('data-km-pid')) - API.count(a.getAttribute('data-km-pid'));
    });
    bought.concat(rest).forEach(function (c) { grid.appendChild(c); });
  }

  function mountPriorityToggle() {
    if (!HAS_ANY) return;
    var bar = document.querySelector('.kmall-sortbar');
    var grid = document.querySelector('.kmall-grid');
    if (!bar || !grid || bar.querySelector('[data-km-prio]')) return;
    /* 현재 페이지에 산 적 있는 상품이 하나도 없으면 토글을 보여줄 이유가 없다 */
    var any = false;
    var cs = grid.querySelectorAll('.kmall-pc[data-km-pid]');
    for (var i = 0; i < cs.length; i++) {
      if (API.count(cs[i].getAttribute('data-km-pid'))) { any = true; break; }
    }
    if (!any) return;

    var on = prioOn();
    var a = document.createElement('button');
    a.type = 'button';
    a.className = 'kmall-instock km-prio' + (on ? ' on' : '');
    a.setAttribute('data-km-prio', '');
    a.setAttribute('role', 'switch');
    a.setAttribute('aria-checked', on ? 'true' : 'false');
    a.innerHTML = '<span class="km-sw" aria-hidden="true"></span>' +
      (I18N.priorityOn || 'Bought before first');
    a.addEventListener('click', function () {
      var next = !a.classList.contains('on');
      a.classList.toggle('on', next);
      a.setAttribute('aria-checked', next ? 'true' : 'false');
      setPrio(next);
      applyPriority(grid, next);
    });
    /* 정렬 select 앞에 둔다 */
    var sel = bar.querySelector('.kmall-select');
    var host = sel ? sel.parentNode : bar;
    if (sel) host.insertBefore(a, sel); else host.appendChild(a);
    if (on) applyPriority(grid, true);
  }

  /* ---------------- 자주 산 상품 페이지 ---------------- */

  function mountPage() {
    var page = document.querySelector('[data-km-freq-page]');
    if (!page) return;
    var grid = page.querySelector('[data-km-freq-grid]');
    var input = page.querySelector('[data-km-freq-q]');
    var soldout = page.querySelector('[data-km-freq-soldout]');
    var sort = page.querySelector('[data-km-freq-sort]');
    var empty = page.querySelector('[data-km-freq-empty]');
    var summary = page.querySelector('[data-km-freq-summary]');
    if (!grid) return;

    var cards = [].slice.call(grid.querySelectorAll('.kmall-pc[data-km-pid]'));
    cards.forEach(function (c) {
      c.__q = (c.getAttribute('data-km-name') || '').toLowerCase();
      c.__n = API.count(c.getAttribute('data-km-pid'));
      c.__r = API.recency(c.getAttribute('data-km-pid'));
      c.__so = c.classList.contains('soldout');
    });

    function render() {
      var q = (input && input.value || '').trim().toLowerCase();
      var hideSold = !!(soldout && soldout.checked);
      var mode = sort ? sort.value : 'count';

      var vis = cards.filter(function (c) {
        if (hideSold && c.__so) return false;
        if (q && c.__q.indexOf(q) < 0) return false;
        return true;
      });
      vis.sort(mode === 'recent'
        ? function (a, b) { return (a.__r - b.__r) || (b.__n - a.__n); }
        : function (a, b) { return (b.__n - a.__n) || (a.__r - b.__r); });

      cards.forEach(function (c) { c.hidden = true; });
      vis.forEach(function (c) { c.hidden = false; grid.appendChild(c); });

      if (empty) {
        empty.hidden = vis.length > 0;
        if (!vis.length && q) empty.textContent = I18N.emptySearch || empty.textContent;
      }
      if (summary) summary.textContent = fill(I18N.countSummary, vis.length, '__N__');
    }

    if (input) input.addEventListener('input', render);
    if (soldout) soldout.addEventListener('change', render);
    if (sort) sort.addEventListener('change', render);
    render();
  }

  /* ---------------- 시작 ---------------- */

  function init() {
    decorate(document);
    watch();
    mountPriorityToggle();
    mountPage();
    if (window.__kmAtcHydrate) window.__kmAtcHydrate();
    if (window.__kmFaveMark) window.__kmFaveMark();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
